import { useState } from "react"
import { useTranslation } from "react-i18next"

export default function ContactWidget() {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="fixed bottom-6 right-6 z-40 w-14 h-14 bg-lib-accent hover:bg-lib-accent-dark rounded-full flex items-center justify-center text-white shadow-lg shadow-lib-primary/20 transition-all duration-300 hover:scale-110"
        aria-label={t("contactWidget.aria", "Связаться с нами")}
      >
        <i className="ri-chat-3-line text-2xl" aria-hidden />
      </button>

      {open ? (
        <div className="fixed inset-0 z-[60] flex items-center justify-center p-4" role="dialog" aria-modal="true">
          <div className="absolute inset-0 bg-lib-primary/30 backdrop-blur-sm" onClick={() => setOpen(false)} aria-hidden />
          <div className="relative bg-lib-card rounded-2xl p-8 max-w-sm w-full text-center border border-lib-border animate-scale-in">
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center text-lib-text-muted hover:text-lib-text transition-colors"
              aria-label={t("common.close", "Закрыть")}
            >
              <i className="ri-close-line text-xl" aria-hidden />
            </button>

            <h3 className="font-serif text-xl text-lib-text mb-2">{t("contactWidget.title", "Связаться с нами")}</h3>
            <p className="text-lib-text-secondary text-sm mb-6">
              {t("contactWidget.subtitle", "Напишите нам в Telegram или VK, и мы ответим в ближайшее время.")}
            </p>

            <div className="flex flex-col gap-3">
              <a
                href="https://t.me/leninka_ru"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#0088cc] hover:bg-[#0077b3] text-white text-sm font-medium rounded-lg transition-colors"
              >
                <i className="ri-telegram-line text-lg" aria-hidden />
                Telegram
              </a>
              <a
                href="http://vk.com/leninka_ru"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#4A76A8] hover:bg-[#3d6391] text-white text-sm font-medium rounded-lg transition-colors"
              >
                <i className="ri-vk-line text-lg" aria-hidden />
                ВКонтакте
              </a>
            </div>
          </div>
        </div>
      ) : null}
    </>
  )
}
